<template>
  <div>
    <!-- MOBILE MENU -->
    <transition
      enter-active-class="transition-transform ease-in-out duration-300"
      enter-from-class="-translate-x-full"
      enter-to-class="translate-x-0"
      leave-active-class="transition-transform ease-in-out duration-300"
      leave-from-class="translate-x-0"
      leave-to-class="-translate-x-full"
    >
      <div
        v-if="mobileSidebarOpen"
        v-cloak
        class="xl:hidden fixed top-0 left-0 align-top w-screen md:w-72 min-w-full md:min-w-min min-h-screen px-4 pb-4 md:px-6 z-30 transform"
        :class="{
          'pt-navbar': !$store.state.nav.announcementBarExists,
          'pt-32': $store.state.nav.announcementBarExists,
        }"
        :style="`background-color: ${$store.state.config.backgroundColor2};`"
        role="navigation"
      >
        <!-- MOBILE SIDEBAR LINKS -->
        <ul class="pt-3 text-xl font-medium tracking-wider font-futura-book">
          <li
            v-for="link in mobileNavTree"
            :key="link.title"
            class="mb-4"
          >
            <sidebar-link :link="link" />
          </li>
          <div v-if="$store.state.config.customer">
            <li class="mb-0 pt-4 border-t border-gray-600">
              <a
                class="inline-block text-base"
                :href="$store.state.config.accountUrl"
              >{{ strings.sidebar.your_account }}</a>
            </li>
          </div>
          <div v-else>
            <li class="mb-0 pt-4 border-t border-gray-600">
              <a
                class="inline-block text-base"
                :href="$store.state.config.loginUrl"
              >{{ strings.sidebar.login }}</a>
            </li>
            <li class="mt-2">
              <a
                class="inline-block text-base"
                :href="$store.state.config.signUpUrl"
              >{{ strings.sidebar.sign_up }}</a>
            </li>
          </div>
        </ul>
      </div>
    </transition>

    <!-- DESKTOP MENU -->
    <transition
      enter-active-class="transition-transform ease-in-out duration-300"
      enter-from-class="translate-x-72 xl:translate-x-96"
      enter-to-class="translate-x-0"
      leave-active-class="transition-transform ease-in-out duration-300"
      leave-from-class="translate-x-0"
      leave-to-class="translate-x-72 xl:translate-x-96"
    >
      <div
        v-if="desktopSidebarOpen"
        v-cloak
        v-click-away="clickaway"
        class="hidden xl:block fixed top-0 right-0 align-top w-72 xl:w-96 h-full px-8 pt-24 z-30 transform"
        :style="`background-color: ${$store.state.config.backgroundColor2};`"
        role="navigation"
      >
        <!-- DESKTOP LINKS -->
        <ul class="block pl-4 pt-1">
          <li
            v-for="link in desktopSidebarLinks"
            :key="link.title"
            class="text-2xl font-futura-book mt-2 mb-3 hover:underline hover:decoration-2 hover:underline-offset-4"
          >
            <a
              :href="link.url"
              v-text="link.title"
            />
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapMutations } = createNamespacedHelpers('nav')

export default {
  data() {
    return {
      strings: window.themeVariables.i18n,
    }
  },
  computed: mapState([
    'desktopSidebarOpen',
    'desktopSidebarLinks',
    'mobileSidebarOpen',
    'mobileNavTree',
  ]),
  methods: {
    ...mapMutations(['closeDesktopSidebar']),
    clickaway(event) {
      if (!event.target.classList.contains('navbar-link')) {
        this.closeDesktopSidebar()
      }
    },
  },
}
</script>